import { useEffect, useState } from "react";

const Hero = () => {
  const [light, setLight] = useState(false);
  let data;

  useEffect(() => {
    const activateComunication = () => {
      data = setInterval(() => {
        setLight(() => !light);
      }, 5000);
    };

    activateComunication();
    return () => clearInterval(data);
  });

  return (
    <div className="container-wrapper">
      <div className="container">
        <div className="content">
          <div className="text">
            <div className="caption">Server Technology</div>

            <p className="paragraph">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut
              accusantium facere asperiores doloribus hic, tempora distinctio
              omnis vero sed libero praesentium reiciendis qui temporibus minima
              eveniet, quos ipsum officiis veniam.
            </p>
          </div>
          <div className="hero-svg-wrapper">
            <svg
              className="hero-svg"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 579.36 378.47"
            >
              <defs>
                <clipPath id="clippath">
                  <ellipse
                    className="cls-16"
                    cx="318.88"
                    cy="330"
                    rx="14.04"
                    ry="24.31"
                    transform="translate(-122.28 203.66) rotate(-30)"
                  />
                </clipPath>
                <linearGradient
                  id="_Áåçûìÿííûé_ãðàäèåíò_15"
                  x1="504.11"
                  y1="309.85"
                  x2="562.68"
                  y2="309.85"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" stopColor="#17e8f7" />
                  <stop offset=".22" stopColor="#5ab0d7" />
                  <stop offset=".67" stopColor="#e24098" />
                </linearGradient>
              </defs>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        className="cls-3"
                        d="m515.05,128.24l-24.41-14.1,24.41-14.09,24.41,14.1-24.41,14.09Zm-22.29-14.1l22.29,12.87,22.29-12.87-22.29-12.87-22.29,12.87Z"
                      />
                      <polygon
                        className="cls-6"
                        points="531.11 109.51 515.05 118.78 515.05 100.23 531.11 90.96 531.11 109.51"
                      />
                      <polygon
                        className="cls-13"
                        points="515.05 100.23 498.99 90.96 515.05 81.69 531.11 90.96 515.05 100.23"
                      />
                      <polygon
                        className="cls-18"
                        points="515.05 118.78 498.99 109.51 498.99 90.96 515.05 100.23 515.05 118.78"
                      />
                    </g>
                    <polygon
                      className="cls-3"
                      points="509.26 108.76 504.77 106.17 504.77 100.98 509.26 103.57 509.26 108.76"
                    />
                  </g>
                  <path
                    className="cls-3"
                    d="m303.09,77.01l-55.98-32.44,62.73-36.12,55.98,32.44-62.73,36.12Zm-53.86-32.43l53.86,31.21,60.61-34.89-53.86-31.21-60.61,34.89Z"
                  />
                  <g>
                    <g>
                      <path
                        className="cls-6"
                        d="m339.78,40.17l-5.44-3.14,20.06-11.58c.95-.55.95-1.44,0-1.98l-20.49-11.83c-.95-.55-2.49-.55-3.44,0l-20.06,11.58-5.44-3.14,20.06-11.58c3.95-2.28,10.37-2.28,14.32,0l20.49,11.83c3.95,2.28,3.95,5.99,0,8.27l-20.06,11.58Z"
                      />
                      <g>
                        <path
                          className="cls-13"
                          d="m348.56,41.55c0-2.91-1.77-6.29-3.95-7.55l-36.35-20.98c-.98-.56-1.87-.6-2.56-.22h0s-43.4,25.22-43.4,25.22l41.97,31.62,42.75-24.82c.13-.06.26-.13.38-.22h0s0,0,0,0c.71-.54,1.16-1.6,1.16-3.05Z"
                        />
                        <path
                          className="cls-14"
                          d="m304.27,69.64l42.75-24.81c.13-.06.26-.13.38-.22h0s0,0,0,0c.71-.54,1.16-1.6,1.16-3.05s-.41-2.88-1.06-4.2l-48.74,28.14,5.51,4.15Z"
                        />
                        <path
                          className="cls-6"
                          d="m301.54,69.53l-36.35-20.98c-2.18-1.26-3.95-4.64-3.95-7.55h0c0-2.91,1.77-4.25,3.95-2.99l36.35,20.98c2.18,1.26,3.95,4.64,3.95,7.55h0c0,2.91-1.77,4.25-3.95,2.99Z"
                        />
                        <path
                          className="cls-3"
                          d="m301.97,58.79l-36.35-20.98c-1-.58-1.92-.6-2.61-.18.62-.19,1.37-.08,2.18.38l36.35,20.98c2.18,1.26,3.95,4.64,3.95,7.55h0c0,1.57-.52,2.68-1.34,3.17,1.07-.33,1.78-1.53,1.78-3.37h0c0-2.91-1.77-6.29-3.95-7.55Z"
                        />
                      </g>
                      <path
                        className="cls-7"
                        d="m296.09,62.45l-4.37-2.52c-.43-.25-.79-.92-.79-1.5h0c0-.58.35-.85.79-.6l4.37,2.52c.43.25.79.92.79,1.5h0c0,.58-.35.85-.79.6Z"
                      />
                    </g>
                    <g>
                      <path
                        className="cls-18"
                        d="m301.68,32.98c1.14-.68,1.13-1.75-.03-2.4-1.16-.65-3.02-.63-4.16.04-1.14.68-1.13,1.75.03,2.4,1.16.65,3.02.63,4.16-.04Z"
                      />
                      <path
                        className="cls-3"
                        d="m308.02,36.56c1.14-.68,1.13-1.75-.03-2.4s-3.02-.63-4.16.04c-1.14.68-1.13,1.75.03,2.4,1.16.65,3.02.63,4.16-.04Z"
                      />
                      <path
                        className="cls-3"
                        d="m314.36,40.13c1.14-.68,1.13-1.75-.03-2.4-1.16-.65-3.02-.63-4.16.04s-1.13,1.75.03,2.4c1.16.65,3.02.63,4.16-.04Z"
                      />
                    </g>
                  </g>
                  <path
                    className="cls-3"
                    d="m177.91,139.34l-90.07-52.15,69.08-39.8,90.07,52.15-69.08,39.8Zm-87.95-52.15l87.95,50.92,66.95-38.58-87.95-50.92-66.95,38.58Z"
                  />
                  <polyline
                    className="cls-3"
                    points="133.38 114.77 100.99 132.25 100.48 131.31 132.33 114.13"
                  />
                  <polygon
                    className="cls-3"
                    points="100.97 131.05 217.42 198.37 216.86 199.34 100.68 132.19 99.93 131.7 100.97 131.05"
                  />
                  <path
                    className="cls-3"
                    d="m509.38,225.66l-.27-.15-119.73-69.25,69.08-39.8.27.15,119.73,69.25-69.08,39.8Zm-117.88-69.4l117.88,68.17,66.95-38.58-117.88-68.17-66.95,38.58Z"
                  />
                  <path
                    className="cls-3"
                    d="m275.27,312.11l-.27-.15-127.24-73.31.8-.46,155.61-89.84.27.15,127.24,73.31-.8.46-155.61,89.84Zm-125.38-73.46l125.38,72.24,154.28-89.08-125.38-72.24-154.28,89.08Z"
                  />
                  <rect
                    className="cls-3"
                    x="291.03"
                    y="121.92"
                    width="126.46"
                    height="1.06"
                    transform="translate(-13.79 193.42) rotate(-29.98)"
                  />
                  <path
                    className="cls-3"
                    d="m136.82,115.02c-1.38.8-3.61.8-4.99,0s-1.38-2.09,0-2.88c1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                  />
                  <path
                    className="cls-3"
                    d="m459.26,196.19c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0s1.38,2.09,0,2.88Z"
                  />
                  <path
                    className="cls-3"
                    d="m336.75,59.94c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88s3.61-.8,4.99,0c1.38.8,1.38,2.09,0,2.88Z"
                  />
                  <path
                    className={`cls-3 floor-light-top-right ${
                      light && "floor-light-movement-top-right"
                    }`}
                    d="m396.55,202.21c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                  />
                  <path
                    className="cls-3"
                    d="m122.86,374.66l-.26-.15-91.23-52.89,39.06-22.55.26.15,91.24,52.89-39.06,22.55Zm-89.41-53.04l89.41,51.83,36.97-21.34-89.41-51.83-36.97,21.34Z"
                  />
                  <path
                    className="cls-3"
                    d="m345.35,374.53l-31.16-17.99,47.89-27.65,31.16,17.99-47.89,27.65Zm-28.71-17.99l28.71,16.57,45.43-26.23-28.71-16.57-45.43,26.23Z"
                  />
                  <g id="pa-system">
                    <g>
                      <path
                        className="cls-6"
                        d="m359.44,342.2v-3.25s3.85-19.36,3.85-19.36l-3.8-2.34-7.6,4.2-.05,24.95c0,1.68.63,2.81,1.59,3.18h0s3.38,2.13,3.38,2.13l.42-1.61.58-2.93c.98-1.44,1.62-3.29,1.62-4.97Z"
                      />
                      <path
                        className="cls-18"
                        d="m359.42,351.64h0c-2.1,1.16-3.8-.14-3.79-2.89l.05-24.95,7.6-4.2-.05,24.95c0,2.76-1.71,5.93-3.81,7.09Z"
                      />
                    </g>
                    <g>
                      <path
                        className="cls-18"
                        d="m379.94,306.16c0,6.33-4.45,8.9-9.93,5.73-5.48-3.17-9.93-10.87-9.93-17.2s4.45-8.9,9.93-5.73c5.48,3.17,9.93,10.87,9.93,17.2Z"
                      />
                      <polygon
                        className="cls-18"
                        points="377.13 312.53 348.23 329.1 332.69 305.76 362.8 288.38 377.13 312.53"
                      />
                    </g>
                    <path
                      className="cls-13"
                      d="m365.77,314.62c0-6.51-4.57-14.43-10.21-17.69-2.56-1.48-4.9-1.74-6.7-.97h0s-.04.01-.04.01c-.02,0-.03.01-.05.02-.08.04-.16.07-.23.11-10.67,5.24-22.47,7.75-34.35,7.29l-3.37-.13,27.4,46.95,1.48-2.87c5.41-10.46,13.32-19.42,23.02-26.08,1.88-1.05,3.04-3.35,3.04-6.64Z"
                    />
                    <path
                      className="cls-13"
                      d="m341.41,339.6c0-12.5-8.77-27.69-19.59-33.94-5.4-3.12-10.28-3.42-13.83-1.39h0s-.02.01-.02.01c0,0-.02.01-.03.02l-3.21,1.88,1.12-.23c-2.29,2.38-3.63,6.13-3.63,11.03,0,12.5,8.77,27.69,19.59,33.94,4.25,2.45,8.18,3.16,11.39,2.36l-.51.75,2.96-1.73s.03-.02.05-.03l.11-.06h0c3.47-2.08,5.61-6.44,5.61-12.61Z"
                    />
                    <path
                      className="cls-3"
                      d="m339.12,340.93c0-12.5-8.77-27.69-19.59-33.94-5.32-3.07-10.15-3.41-13.68-1.47l-.49.29c-.17.11-.33.22-.49.34l1-.21c-2.29,2.38-3.63,6.13-3.63,11.03,0,12.5,8.77,27.69,19.59,33.94,4.25,2.45,8.18,3.16,11.39,2.36l-.46.68c3.92-1.87,6.38-6.41,6.38-13.02Z"
                    />
                    <ellipse
                      className="cls-18"
                      cx="318.88"
                      cy="330"
                      rx="16"
                      ry="27.71"
                      transform="translate(-122.28 203.66) rotate(-30)"
                    />
                    <ellipse
                      className="cls-6"
                      cx="318.88"
                      cy="330"
                      rx="14.04"
                      ry="24.31"
                      transform="translate(-122.28 203.66) rotate(-30)"
                    />
                    <path
                      className="cls-3"
                      d="m319.68,349.51c-9.49-5.48-17.19-18.81-17.19-29.78,0-5.76,2.12-9.71,5.51-11.38-3.86,1.41-6.32,5.53-6.32,11.73,0,10.96,7.7,24.29,17.19,29.78,4.51,2.6,8.61,2.97,11.68,1.46-2.96,1.09-6.75.58-10.87-1.8Z"
                    />
                    <g className="cls-15">
                      <g>
                        <polygon
                          className="cls-13"
                          points="316.3 325.89 341.25 306.61 350.31 322.32 321.03 334.34 316.3 325.89"
                        />
                        <path
                          className="cls-18"
                          d="m322.31,331.99c0,2.19-1.54,3.08-3.43,1.98-1.9-1.09-3.43-3.76-3.43-5.95s1.54-3.08,3.43-1.98c1.9,1.09,3.43,3.76,3.43,5.95Z"
                        />
                      </g>
                    </g>
                    <g className="pa-lamp">
                      <path
                        className="cls-7 pa-lamp"
                        d="m353.8,342.42l-.13-.08c-.5-.29-.91-1.06-.91-1.72v-4.81c-.02-.66.39-.97.89-.68l.13.08c.5.29.9,1.06.91,1.72v4.81c.02.66-.39.97-.89.68Z"
                      />
                    </g>
                  </g>
                  <path
                    className="cls-3"
                    d="m516.48,150.68c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0s1.38,2.09,0,2.88Z"
                  />
                  <g>
                    <path
                      className="cls-3"
                      d="m248.79,369.56l-26.37-15.22,26.36-15.22,26.37,15.22-26.36,15.22Zm-24.24-15.22l24.24,14,24.24-14-24.24-14-24.24,14Z"
                    />
                    <g>
                      <path
                        className="cls-14"
                        d="m272.03,348.6h0v-6.96h-15.61s-5.39-3.12-5.39-3.12c-1.24-.71-3.4-.63-4.83.2l-5.03,2.91h-15.62s0,7.15,0,7.15c-.04.48.23.95.83,1.29l20.17,11.65c1.24.71,3.4.63,4.83-.2l19.48-11.25c.82-.48,1.22-1.09,1.18-1.67Z"
                      />
                      <path
                        className="cls-14"
                        d="m248.79,338.04c-.91.02-1.85.25-2.59.68l-5.03,2.91h-15.62s0,7.15,0,7.15c-.04.48.23.95.83,1.29l20.17,11.65c.59.34,1.4.5,2.24.48v-24.15Z"
                      />
                      <path
                        className="cls-18"
                        d="m227.31,341.62h-1.77s0,7.16,0,7.16c-.04.48.23.95.83,1.29l.94.54v-8.99Z"
                      />
                      <path
                        className="cls-18"
                        d="m246.86,361.87c1.07.46,2.61.43,3.86-.04v-8.13h-3.86v8.17Z"
                      />
                      <path
                        className="cls-13"
                        d="m246.55,354.58l-20.17-11.65c-1.24-.71-1.08-1.96.35-2.79l19.48-11.25c1.43-.83,3.59-.92,4.83-.2l20.17,11.65c1.24.71,1.08,1.96-.35,2.79l-19.48,11.25c-1.43.83-3.59.92-4.83.2Z"
                      />
                      <path
                        className="cls-3"
                        d="m270.85,341.77l-19.48,11.25c-1.43.83-3.59.92-4.83.2l-20.17-11.65c-.28-.16-.48-.35-.62-.55-.43.68-.23,1.43.62,1.92l20.17,11.65c1.24.71,3.4.63,4.83-.2l19.48-11.25c1.11-.64,1.45-1.54.96-2.24-.19.31-.52.61-.96.87Z"
                      />
                      <g>
                        <path
                          className="cls-13"
                          d="m264.61,350.44c0,.52-.36,1.15-.81,1.41-.45.26-.81.05-.81-.47s.36-1.15.81-1.41c.45-.26.81-.05.81.47Z"
                        />
                        <path
                          className="cls-13"
                          d="m267.23,348.93c0,.52-.36,1.15-.81,1.41-.45.26-.81.05-.81-.47s.36-1.15.81-1.41.81-.05.81.47Z"
                        />
                        <path
                          className="cls-13"
                          d="m269.85,347.41c0,.52-.36,1.15-.81,1.41-.45.26-.81.05-.81-.47s.36-1.15.81-1.41c.45-.26.81-.05.81.47Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m247.74,347.36l-9.44-5.45c-.58-.33-.51-.92.16-1.31l9.11-5.26c.67-.39,1.68-.43,2.26-.09l9.44,5.45c.58.33.51.92-.16,1.31l-9.11,5.26c-.67.39-1.68.43-2.26.09Z"
                        />
                        <path
                          className="cls-13"
                          d="m248.64,342.8l-1.31-.75c-.08-.05-.07-.13.02-.18l1.26-.73c.09-.05.23-.06.31-.01l1.31.75c.08.05.07.13-.02.18l-1.26.73c-.09.05-.23.06-.31.01Z"
                        />
                        <path
                          className="cls-14"
                          d="m238.3,341.91l.03.02s.08-.06.14-.09l9.11-5.26c.67-.39,1.68-.43,2.26-.09l9.41,5.43c.53-.38.56-.9.03-1.21l-9.44-5.45c-.58-.33-1.59-.29-2.26.09l-9.11,5.26c-.67.39-.74.97-.16,1.31Z"
                        />
                      </g>
                    </g>
                    <path
                      className="cls-3"
                      d="m238.84,363.12c-1.38.8-3.61.8-4.99,0s-1.38-2.09,0-2.88c1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                    />
                  </g>
                  <path
                    className="cls-3"
                    d="m512.95,56.89l-30.75-17.68,38.92-22.47,30.75,17.68-38.92,22.47Zm-28.62-17.68l28.62,16.46,36.8-21.25-28.62-16.46-36.8,21.25Z"
                  />
                  <g>
                    <g>
                      <path
                        className="cls-18"
                        d="m514.68,48.67l28.48-16.47c.56-.33.83-.76.84-1.22h.01s0-7.48,0-7.48c0,0-1,.84-1.58,1.33l-17.98-10.36c-1.46-.84-3.67-.93-4.94-.2l-27.22,15.75-2.11-1.22v7.52s.01-.01.01-.01c.01.55.41,1.13,1.2,1.58l18.36,10.58c1.46.84,3.67.93,4.94.2Z"
                      />
                      <path
                        className="cls-14"
                        d="m542.42,24.83l-17.98-10.36c-1.46-.84-3.67-.93-4.94-.2l-7.09,4.1v30.79c.85.02,1.67-.14,2.27-.49l28.48-16.47c.56-.33.83-.76.84-1.22h.01s0-7.48,0-7.48c0,0-1,.84-1.58,1.33Z"
                      />
                      <path
                        className="cls-13"
                        d="m491.03,27.5l28.48-16.47c1.27-.73,3.48-.64,4.94.2l18.36,10.58c1.46.84,1.62,2.12.36,2.85l-28.48,16.47c-1.27.73-3.48.64-4.94-.2l-18.36-10.58c-1.46-.84-1.62-2.12-.36-2.85Z"
                      />
                      <path
                        className="cls-3"
                        d="m514.61,41.89l28.48-16.47c.69-.4.94-.97.8-1.53-.13.28-.36.55-.74.77l-28.48,16.47c-1.27.73-3.48.64-4.94-.2l-18.36-10.58c-.66-.38-1.04-.85-1.16-1.32-.31.68.06,1.49,1.09,2.09l18.36,10.58c1.46.84,3.67.93,4.94.2Z"
                      />
                    </g>
                    <g>
                      <path
                        className="cls-3"
                        d="m521.05,22.97c-1.06-.61-1.06-1.61,0-2.22,1.06-.61,2.78-.62,3.84,0,1.06.61,1.06,1.61,0,2.22-1.06.61-2.78.62-3.84,0Z"
                      />
                      <path
                        className="cls-6"
                        d="m515.22,26.34c-1.06-.61-1.06-1.61,0-2.22,1.06-.61,2.78-.62,3.84,0s1.06,1.61,0,2.22c-1.06.61-2.78.62-3.84,0Z"
                      />
                      <path
                        className="cls-14"
                        d="m509.4,29.7c-1.06-.61-1.06-1.61,0-2.22,1.06-.61,2.78-.62,3.84,0,1.06.61,1.06,1.61,0,2.22-1.06.61-2.78.62-3.84,0Z"
                      />
                    </g>
                  </g>
                  <path
                    className="cls-3"
                    d="m378.41,339c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                  />
                  <rect
                    className="cls-3"
                    x="115.93"
                    y="295.94"
                    width="97.98"
                    height="1.06"
                    transform="translate(-126.08 122.07) rotate(-29.98)"
                  />
                  <g>
                    <g id="top-computer">
                      <path
                        className="cls-6"
                        d="m240.82,37.02L177.74,2.27c-.73-.4-1.48-.47-2.14-.25h0s-.11.03-.11.03c0,0-.02,0-.03.01l-2.28.83,2.05.96s-.02.07-.03.11l-11.14,48.37c-.51,2.23.52,4.84,2.3,5.82l61.55,33.92-.22,2.49,2.49-.92c.84-.37,1.51-1.22,1.78-2.42l11.14-48.37c.51-2.23-.52-4.84-2.3-5.82Z"
                      />
                      <path
                        className="cls-14"
                        d="m240.82,37.02L177.74,2.27c-.73-.4-1.48-.47-2.14-.25h0s-.11.03-.11.03c0,0-.02,0-.03.01l-2.28.83,2.05.96s-.02.07-.03.11l-7.64,33.15,30.86,22.94,44.38-20.64c-.42-1.03-1.11-1.91-1.99-2.4Z"
                      />
                      <path
                        className="cls-4"
                        d="m238.44,43.88l4.8-1.95c.09-1.77-.68-3.61-1.95-4.59l-7.6,3.05,4.74,3.49Z"
                      />
                      <path
                        className="cls-13"
                        d="m225.5,94.32l-63.07-34.75c-1.78-.98-2.81-3.59-2.3-5.82l11.14-48.37c.51-2.23,2.38-3.25,4.16-2.26l63.07,34.75c1.78.98,2.81,3.59,2.3,5.82l-11.14,48.37c-.51,2.23-2.38,3.25-4.16,2.26Z"
                      />
                      <path
                        className="cls-3"
                        d="m239.12,37.65L176.04,2.9c-.86-.48-1.74-.48-2.48-.1.59-.12,1.24-.04,1.88.31l63.07,34.75c1.78.98,2.81,3.59,2.3,5.82l-11.14,48.37c-.27,1.15-.89,1.97-1.68,2.37,1.06-.22,1.95-1.14,2.28-2.58l11.14-48.37c.51-2.23-.52-4.84-2.3-5.82Z"
                      />
                      <path
                        className="cls-3"
                        d="m224.14,91l-59.32-32.67c-1.63-.9-2.57-3.29-2.1-5.33l10.27-44.58c.47-2.04,2.18-2.97,3.81-2.07l59.32,32.67c1.63.9,2.57,3.29,2.1,5.33l-10.27,44.58c-.47,2.04-2.18,2.97-3.81,2.07Z"
                      />
                      <path
                        className="cls-6"
                        d="m224.14,91l-59.32-32.67c-1.63-.9-2.57-3.29-2.1-5.33l10.27-44.58c.47-2.04,2.18-2.97,3.81-2.07l59.32,32.67c1.63.9,2.57,3.29,2.1,5.33l-10.27,44.58c-.47,2.04-2.18,2.97-3.81,2.07Z"
                      />
                      <path
                        className="cls-18"
                        d="m224.65,90.8l-59.32-32.67c-1.63-.9-2.57-3.29-2.1-5.33l10.27-44.58c.24-1.03.79-1.78,1.49-2.15-.94.23-1.72,1.07-2.01,2.35l-10.27,44.58c-.47,2.04.47,4.43,2.1,5.33l59.32,32.67c.81.44,1.63.44,2.31.08-.56.14-1.18.06-1.8-.28Z"
                      />
                      <path
                        className="cls-6"
                        d="m226.38,95.83l-8.62-1.09-55.65-30.66c-1.78-.98-4.9-.86-6.96.28l-39.44,21.72-5.21-.66v2.82h0c-.03.65.36,1.28,1.2,1.74l63.07,34.75c1.78.98,4.9.86,6.96-.28l42.95-23.66c1.16-.64,1.74-1.46,1.7-2.23h0v-2.74Z"
                      />
                      <path
                        className="cls-14"
                        d="m184.56,76.46l-3.95-2.18h-43.47l-21.43,11.8-5.21-.66v2.82h0c-.03.65.36,1.28,1.2,1.74l63.07,34.75c.94.52,2.26.73,3.59.64l6.2-48.93Z"
                      />
                      <path
                        className="cls-18"
                        d="m112.8,85.71l-2.31-.29v2.82h0c-.03.65.36,1.28,1.2,1.74l1.11.61v-4.89Z"
                      />
                      <path
                        className="cls-4"
                        d="m175.4,125.02c1.69.61,4.11.48,5.91-.35v-6.3h-5.91v6.65Z"
                      />
                      <path
                        className="cls-13"
                        d="m174.76,121.92l-63.07-34.75c-1.78-.98-1.56-2.7.5-3.84l42.95-23.66c2.06-1.14,5.18-1.26,6.96-.28l63.07,34.75c1.78.98,1.56,2.7-.5,3.84l-42.95,23.66c-2.06,1.14-5.18,1.26-6.96.28Z"
                      />
                      <path
                        className="cls-3"
                        d="m224.67,96.96l-42.95,23.66c-2.06,1.14-5.18,1.26-6.96.28l-63.07-34.75c-.59-.32-.95-.72-1.11-1.16-.28.81.08,1.62,1.11,2.19l63.07,34.75c1.78.98,4.9.86,6.96-.28l42.95-23.66c1.38-.76,1.94-1.79,1.61-2.68-.2.59-.74,1.17-1.61,1.65Z"
                      />
                      <g>
                        <path
                          className="cls-18"
                          d="m138.52,75.66l-2.85-1.57c-.23-.13-.2-.35.06-.49l3.37-1.86c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-3.37,1.86c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m142.93,78.09l-2.85-1.57c-.23-.13-.2-.35.06-.49l3.37-1.86c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-3.37,1.86c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m147.33,80.52l-2.85-1.57c-.23-.13-.2-.35.06-.49l3.37-1.86c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-3.37,1.86c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m153.43,78.52l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m157.83,80.94l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m162.24,83.37l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m166.65,85.8l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m171.06,88.23l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m175.46,90.66l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m179.87,93.08l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m184.28,95.51l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m188.68,97.94l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m193.09,100.37l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m159.92,77.37l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m155.45,74.9l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m150.97,72.43l-6.15-3.39c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l6.15,3.39c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m154.1,69.43l-4.99-2.75c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l4.99,2.75c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m164.33,79.79l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m168.73,82.22l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m173.14,84.65l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m177.55,87.08l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m181.96,89.51l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m186.36,91.93l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m190.77,94.36l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m195.18,96.79l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m199.58,99.22l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m207.42,103.54l-6.23-3.43c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l6.23,3.43c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m216,98.81l-5.26-2.9c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l5.26,2.9c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m172.05,79.32l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m167.53,76.83l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m163.01,74.34l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m158.5,71.85l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m176.45,81.75l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m180.86,84.17l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m185.27,86.6l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m189.67,89.03l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m194.08,91.46l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m198.49,93.89l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m202.89,96.32l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m207.3,98.74l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m211.71,101.17l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m169.72,73.31l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m165.34,70.9l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m160.95,68.48l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m156.57,66.06l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m161.08,63.58l-2.85-1.57c-.23-.13-.2-.35.06-.49l.93-.52c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-.93.51c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m166.8,66.73l-2.85-1.57c-.23-.13-.2-.35.06-.49l.93-.52c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-.93.51c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m171.17,69.14l-2.85-1.57c-.23-.13-.2-.35.06-.49l.93-.51c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-.93.52c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m175.54,71.54l-2.85-1.57c-.23-.13-.2-.35.06-.49l.93-.52c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-.93.51c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m179.9,73.95l-2.85-1.57c-.23-.13-.2-.35.06-.49l.93-.51c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-.93.52c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m204.28,87.38l-2.85-1.57c-.23-.13-.2-.35.06-.49l.93-.51c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-.93.52c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m208.65,89.79l-2.85-1.57c-.23-.13-.2-.35.06-.49l.93-.52c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-.93.51c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m213.01,92.2l-2.85-1.57c-.23-.13-.2-.35.06-.49l.93-.51c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-.93.51c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m217.38,94.6l-2.85-1.57c-.23-.13-.2-.35.06-.49l.93-.52c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-.93.51c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m174.13,75.74l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m178.54,78.17l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m182.95,80.6l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m187.35,83.03l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m191.76,85.45l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m196.17,87.88l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m200.57,90.31l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m204.98,92.74l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m209.39,95.17l-2.85-1.57c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m148.94,76.04l-8.4-4.63c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l8.4,4.63c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m203.08,105.87l-8.4-4.63c-.23-.13-.2-.35.06-.49l2.83-1.56c.26-.15.66-.16.89-.04l8.4,4.63c.23.13.2.35-.06.49l-2.83,1.56c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m185.45,101.52l-2.85-1.57c-.23-.13-.2-.35.06-.49l3.37-1.86c.26-.15.66-.16.89-.04l2.85,1.57c.23.13.2.35-.06.49l-3.37,1.86c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m153.45,83.89l-4.56-2.51c-.23-.13-.2-.35.06-.49l3.37-1.86c.26-.15.66-.16.89-.04l4.56,2.51c.23.13.2.35-.06.49l-3.37,1.86c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m181.21,99.18l-4.56-2.51c-.23-.13-.2-.35.06-.49l3.37-1.86c.26-.15.66-.16.89-.04l4.56,2.51c.23.13.2.35-.06.49l-3.37,1.86c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m159.81,87.39l-4.56-2.51c-.23-.13-.2-.35.06-.49l3.37-1.86c.26-.15.66-.16.89-.04l4.56,2.51c.23.13.2.35-.06.49l-3.37,1.86c-.26.15-.66.16-.89.04Z"
                        />
                        <path
                          className="cls-18"
                          d="m159.6,82.51l19.84,10.93c.25.14.25.36,0,.49l-3.43,1.89c-.25.14-.65.14-.89,0l-19.84-10.93,4.33-2.38Z"
                        />
                        <path
                          className="cls-18"
                          d="m197.77,105.93l3.18,1.75c.19.1.16.28-.05.4l-1.38.76c-.22.12-.54.13-.73.03l-3.18-1.75c-.19-.1-.16-.28.05-.4l1.38-.76c.22-.12.54-.13.73-.03Z"
                        />
                        <path
                          className="cls-18"
                          d="m193.33,103.48l3.18,1.75c.19.1.16.28-.05.4l-1.38.76c-.22.12-.54.13-.73.03l-3.18-1.75c-.19-.1-.16-.28.05-.4l1.38-.76c.22-.12.54-.13.73-.03Z"
                        />
                        <path
                          className="cls-18"
                          d="m188.92,101.05l3.18,1.75c.19.1.16.28-.05.4l-1.38.76c-.22.12-.54.13-.73.03l-3.18-1.75c-.19-.1-.16-.28.05-.4l1.38-.76c.22-.12.54-.13.73-.03Z"
                        />
                        <path
                          className="cls-18"
                          d="m195.76,102.14l3.18,1.75c.19.1.16.28-.05.4l-1.38.76c-.22.12-.54.13-.73.03l-3.18-1.75c-.19-.1-.16-.28.05-.4l1.38-.76c.22-.12.54-.13.73-.03Z"
                        />
                      </g>
                      <g>
                        <polygon
                          className="cls-13"
                          points="186.9 28.83 179.73 24.88 180.04 23.41 187.21 27.36 186.9 28.83"
                        />
                        <polygon
                          className="cls-3"
                          points="186.12 32.25 178.96 28.3 179.26 26.83 186.43 30.78 186.12 32.25"
                        />
                        <polygon
                          className="cls-13"
                          points="221.31 79.72 214.14 75.78 214.44 74.3 221.61 78.25 221.31 79.72"
                        />
                        <polygon
                          className="cls-13"
                          points="184.57 39.1 177.4 35.15 177.71 33.67 184.87 37.62 184.57 39.1"
                        />
                      </g>
                    </g>
                    <g>
                      <path
                        className="cls-7"
                        d="m199.13,46.37l-7.23-3.98c-.64-.35-1.02-1.23-.85-1.95l1.57-6.74c.17-.72.82-1.03,1.46-.67l7.23,3.98c.64.35,1.02,1.23.85,1.95l-1.57,6.74c-.17.72-.82,1.03-1.46.67Z"
                      />
                      <path
                        className="cls-17 top-computer-rec-1"
                        d="m211.73,53.31l-7.23-3.98c-.64-.35-1.02-1.23-.85-1.95l1.57-6.74c.17-.72.82-1.03,1.46-.67l7.23,3.98c.64.35,1.02,1.23.85,1.95l-1.57,6.74c-.17.72-.82,1.03-1.46.67Z"
                      />
                      <path
                        className="cls-3 top-computer-rec-2"
                        d="m196.33,58.33l-7.23-3.98c-.64-.35-1.02-1.23-.85-1.95l1.57-6.74c.17-.72.82-1.03,1.46-.67l7.23,3.98c.64.35,1.02,1.23.85,1.95l-1.57,6.74c-.17.72-.82,1.03-1.46.67Z"
                      />
                      <path
                        className="cls-14"
                        d="m208.94,65.28l-7.23-3.98c-.64-.35-1.02-1.23-.85-1.95l1.57-6.74c.17-.72.82-1.03,1.46-.67l7.23,3.98c.64.35,1.02,1.23.85,1.95l-1.57,6.74c-.17.72-.82,1.03-1.46.67Z"
                      />
                    </g>
                  </g>
                  <g>
                    <g id="iphone">
                      <g>
                        <path
                          className="cls-14"
                          d="m513.8,213.81l44.26-25.63c1.45-.84,2.13-1.98,2.08-3.16h0s-.02-6.42-.02-6.42l-2.46,2.88c-.16-.11-.32-.21-.5-.31l-90.54-52.11c-3.59-2.07-9.03-2.29-12.14-.49l-43.64,25.27c-.88-.97-2.73-3.01-2.73-3.01l.02,6.28h0c-.07,1.42.94,2.92,2.97,4.09l90.54,52.11c3.59,2.07,9.03,2.29,12.14.49Z"
                        />
                        <path
                          className="cls-6"
                          d="m537.73,198.08l-2.55,1.47c-.34.2-.61-.01-.61-.46h0c0-.45.27-.98.61-1.17l2.55-1.47c.34-.2.61.01.61.46h0c0,.45-.27.98-.61,1.17Z"
                        />
                        <path
                          className="cls-18"
                          d="m466.64,129.07c-3.59-2.07-9.03-2.29-12.14-.49l-43.64,25.27c-.88-.97-2.73-3.01-2.73-3.01l.02,6.28h0c-.07,1.42.94,2.92,2.97,4.09l90.54,52.11c1.88,1.08,4.25,1.65,6.53,1.7l-.09-62.08-41.47-23.87Z"
                        />
                        <path
                          className="cls-13"
                          d="m410.22,147.75l44.26-25.63c3.11-1.8,8.54-1.58,12.14.49l90.54,52.11c3.59,2.07,3.99,5.2.88,7.01l-44.26,25.63c-3.11,1.8-8.54,1.58-12.14-.49l-90.54-52.11c-3.59-2.07-3.99-5.2-.88-7.01Z"
                        />
                        <path
                          className="cls-3"
                          d="m513.81,208.03l44.26-25.63c1.6-.93,2.27-2.21,2.05-3.52-.08,1.06-.76,2.07-2.08,2.84l-44.26,25.63c-3.11,1.8-8.54,1.58-12.14-.49l-90.54-52.11c-1.74-1-2.72-2.25-2.93-3.48-.11,1.44.9,2.98,2.96,4.17l90.54,52.11c3.59,2.07,9.03,2.29,12.14.49Z"
                        />
                        <path
                          className="cls-6"
                          d="m413.63,148.76l42.53-24.63c2.31-1.34,6.35-1.18,9.02.36l89.25,51.37c2.67,1.54,2.96,3.87.65,5.21l-42.53,24.63c-2.31,1.34-6.35,1.18-9.02-.36l-89.25-51.37c-2.67-1.54-2.96-3.87-.65-5.21Z"
                        />
                      </g>
                      <g>
                        <polygon
                          className="cls-13"
                          points="501.85 192.91 531.86 175.58 529.94 174.47 499.93 191.8 501.85 192.91"
                        />
                        <polygon
                          className="cls-13"
                          points="522.73 187.85 537.92 179.08 536.01 177.98 520.81 186.75 522.73 187.85"
                        />
                        <polygon
                          className="cls-7"
                          points="515.36 192.11 520.28 189.27 518.37 188.16 513.44 191.01 515.36 192.11"
                        />
                        <polygon
                          className="cls-3"
                          points="507.91 196.41 512.84 193.56 510.93 192.46 506 195.3 507.91 196.41"
                        />
                        <polygon
                          className="cls-3"
                          points="522.56 184.45 534.89 177.33 532.98 176.22 520.64 183.34 522.56 184.45"
                        />
                        <polygon
                          className="cls-13"
                          points="507.51 193.14 519.84 186.02 517.92 184.92 505.59 192.04 507.51 193.14"
                        />
                        <g>
                          <path
                            className="cls-7"
                            d="m516.64,177.92c.62.36,1.62.36,2.23,0,.62-.36.62-.93,0-1.29s-1.62-.36-2.23,0c-.62.36-.62.93,0,1.29Z"
                          />
                          <path
                            className="cls-3"
                            d="m513.3,179.85c.62.36,1.62.36,2.23,0,.62-.36.62-.93,0-1.29s-1.62-.36-2.23,0c-.62.36-.62.93,0,1.29Z"
                          />
                          <path
                            className="cls-13"
                            d="m509.96,181.78c.62.36,1.62.36,2.23,0,.62-.36.62-.93,0-1.29-.62-.36-1.62-.36-2.23,0-.62.36-.62.93,0,1.29Z"
                          />
                          <path
                            className="cls-7"
                            d="m506.62,183.71c.62.36,1.62.36,2.23,0,.62-.36.62-.93,0-1.29-.62-.36-1.62-.36-2.23,0-.62.36-.62.93,0,1.29Z"
                          />
                          <path
                            className="cls-3"
                            d="m503.28,185.63c.62.36,1.62.36,2.23,0,.62-.36.62-.93,0-1.29-.62-.36-1.62-.36-2.23,0-.62.36-.62.93,0,1.29Z"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          className="cls-7"
                          points="436.16 148.95 441.21 146.04 439.25 144.9 434.2 147.82 436.16 148.95"
                        />
                        <polygon
                          className="cls-3"
                          points="429.13 153.01 434.18 150.1 432.21 148.96 427.16 151.88 429.13 153.01"
                        />
                        <polygon
                          className="cls-3"
                          points="458.73 135.8 463.78 132.88 461.82 131.75 456.77 134.67 458.73 135.8"
                        />
                        <polygon
                          className="cls-3"
                          points="437.29 151.89 444.32 147.83 442.36 146.7 435.32 150.76 437.29 151.89"
                        />
                        <polygon
                          className="cls-13"
                          points="432.23 154.81 435.32 153.03 433.36 151.89 430.27 153.68 432.23 154.81"
                        />
                      </g>
                    </g>
                    <g>
                      <path
                        className="cls-7 iphone-rec-1"
                        d="m483.73,161.81l5.78-3.38c.51-.3,1.41-.27,2,.07l5.53,3.16c.59.34.66.86.15,1.16l-5.78,3.38c-.51.3-1.41.27-2-.07l-5.53-3.16c-.59-.34-.66-.86-.15-1.16Z"
                      />
                      <path
                        className="cls-17"
                        d="m473.64,167.7l5.78-3.38c.51-.3,1.41-.27,2,.07l5.53,3.16c.59.34.66.86.15,1.16l-5.78,3.38c-.51.3-1.41.27-2-.07l-5.53-3.16c-.59-.34-.66-.86-.15-1.16Z"
                      />
                      <path
                        className="cls-3"
                        d="m473.91,156.2l5.78-3.38c.51-.3,1.41-.27,2,.07l5.53,3.16c.59.34.66.86.15,1.16l-5.78,3.38c-.51.3-1.41.27-2-.07l-5.53-3.16c-.59-.34-.66-.86-.15-1.16Z"
                      />
                      <path
                        className="cls-14 iphone-rec-2"
                        d="m463.82,162.09l5.78-3.38c.51-.3,1.41-.27,2,.07l5.53,3.16c.59.34.66.86.15,1.16l-5.78,3.38c-.51.3-1.41.27-2-.07l-5.53-3.16c-.59-.34-.66-.86-.15-1.16Z"
                      />
                    </g>
                  </g>
                  <path
                    className="cls-3"
                    d="m447.73,113.76l-79.23-45.71,36.56-20.9,79.23,45.71-36.56,20.9Zm-77.1-45.7l77.1,44.48,34.43-19.68-77.1-44.48-34.43,19.68Z"
                  />
                  <g id="camera">
                    <path
                      className="cls-13"
                      d="m462.91,32.7L407.02.43c-.94-.54-1.79-.55-2.44-.14h0s-19.32,11.17-19.32,11.17l18.15,10.84v30.67c0,2.66,1.62,5.74,3.61,6.89l38.16,22.03.78,21.59,19.18-11.1c.09-.04.17-.09.25-.15l.04-.02h0c.67-.49,1.09-1.46,1.09-2.81v-49.83c0-2.66-1.62-5.74-3.61-6.89Z"
                    />
                    <path
                      className="cls-14"
                      d="m430.33,73.34l14.85,8.57.78,21.59,19.18-11.1c.09-.04.17-.09.25-.15l.04-.02h0c.67-.49,1.09-1.46,1.09-2.81v-49.83c0-1.14-.3-2.35-.79-3.46l-35.4,20.44v16.76Z"
                    />
                    <path
                      className="cls-14"
                      d="m443.5,103.38l-55.89-32.27c-1.99-1.15-3.61-4.24-3.61-6.89V14.39c0-2.66,1.62-3.88,3.61-2.73l55.89,32.27c1.99,1.15,3.61,4.24,3.61,6.89v49.83c0,2.66-1.62,3.88-3.61,2.73Z"
                    />
                    <path
                      className="cls-3"
                      d="m444.28,43.49l-55.89-32.27c-1.08-.62-2.03-.53-2.69.08.56-.15,1.21-.05,1.92.36l55.89,32.27c1.99,1.15,3.61,4.24,3.61,6.89v49.83c0,1.22-.35,2.12-.91,2.64,1.01-.27,1.69-1.37,1.69-3.08v-49.83c0-2.66-1.62-5.74-3.61-6.89Z"
                    />
                    <path
                      className="cls-6"
                      d="m446.08,42.43l-55.89-32.27c-1.08-.62-2.04-.55-2.7.07.61-.28,1.38-.22,2.22.26l55.89,32.27c1.99,1.15,3.61,4.24,3.61,6.89v49.83c0,1.22-.34,2.13-.9,2.65.85-.39,1.39-1.45,1.39-2.99v-49.83c0-2.66-1.62-5.74-3.61-6.89Z"
                    />
                    <path
                      className="cls-6"
                      d="m441.87,100.71l-52.63-30.39c-1.88-1.08-3.4-3.99-3.4-6.49V16.91c0-2.5,1.52-3.65,3.4-2.57l52.63,30.39c1.88,1.08,3.4,3.99,3.4,6.49v46.92c0,2.5-1.52,3.65-3.4,2.57Z"
                    />
                    <path
                      className="cls-7 camera-flesh"
                      d="m393.13,24.61c0,.72-.51,1.01-1.13.65-.62-.36-1.13-1.24-1.13-1.96s.51-1.01,1.13-.65c.62.36,1.13,1.24,1.13,1.96Z"
                    />
                    <path
                      className="cls-9"
                      d="m406.93,63.8l-13.63-7.87c-.72-.41-1.3-1.53-1.3-2.48v-15.27c0-.96.58-1.4,1.3-.98l13.63,7.87c.72.41,1.3,1.53,1.3,2.48v15.27c0,.96-.58,1.4-1.3.98Z"
                    />
                    <g>
                      <path
                        className="cls-3"
                        d="m397.2,54.18c-.19.15-.45.12-.81-.08-.35-.2-.62-.48-.8-.85-.19-.36-.28-.76-.28-1.18v-2.11c0-.44.09-.73.27-.88.18-.15.45-.12.81.09.36.21.63.49.81.85.18.36.27.76.27,1.19v2.12c0,.43-.09.71-.28.86Zm-.81-.79c.24.14.36-.03.36-.5v-2.09c0-.06,0-.12,0-.17,0-.05,0-.11-.02-.17,0-.06-.02-.12-.04-.17-.02-.05-.04-.11-.06-.16-.03-.05-.06-.1-.1-.14-.04-.04-.09-.08-.14-.11-.06-.03-.12-.05-.16-.05-.05,0-.08.02-.11.05-.03.03-.04.08-.06.14-.01.06-.02.12-.03.18,0,.06,0,.12,0,.2v2.09c0,.47.12.78.36.92Z"
                      />
                      <path
                        className="cls-3"
                        d="m398.82,55.43v-3.88l-.67-.18v-.61c.43.08.71.07.84-.04l.55.32v4.81l-.71-.41Z"
                      />
                      <path
                        className="cls-3"
                        d="m400.6,54.01v-.78l.68.39v.78l-.68-.39Zm0,1.96v-.78l.68.39v.78l-.68-.39Z"
                      />
                      <path
                        className="cls-3"
                        d="m402.77,57.78c-.37-.21-.65-.49-.82-.83-.18-.34-.27-.73-.27-1.16v-.17l.71.41v.13c0,.25.03.44.08.59.05.15.15.26.3.35.06.04.12.06.16.06.05,0,.08-.01.11-.03.03-.02.05-.07.06-.13.01-.06.02-.12.03-.19,0-.07,0-.15,0-.25,0-.25-.04-.47-.11-.65-.07-.18-.2-.32-.38-.44,0,0-.02-.01-.06-.03-.03-.02-.05-.03-.05-.03v-.69c.05.03.09.05.1.05.18.1.31.12.39.06.07-.06.11-.21.11-.46,0-.21-.03-.39-.08-.53s-.16-.25-.3-.33c-.06-.03-.11-.05-.16-.06-.04,0-.08,0-.11.03-.03.02-.05.06-.06.11-.02.05-.03.11-.03.17,0,.06-.01.13-.01.22v.16l-.71-.41v-.22c0-.41.09-.67.28-.79s.46-.08.8.12c.35.2.62.47.81.8.19.33.28.7.28,1.1,0,.27-.05.47-.15.59-.1.12-.24.16-.41.12.18.17.32.39.42.64.1.25.15.53.15.85,0,.46-.09.77-.26.92-.17.16-.45.13-.82-.09Z"
                      />
                      <path
                        className="cls-3"
                        d="m404.5,58.71l.81-3.71-1.1-.64v-.63l1.8,1.04v.48l-.82,3.85-.69-.4Z"
                      />
                    </g>
                    <g>
                      <path
                        className="cls-13"
                        d="m440.24,47.37l-25.76-14.84c-.55-.32-1.06-.32-1.43-.08h0s-6.36,3.66-6.36,3.66l10.68,6.38v18.05c0,1.56.95,3.38,2.12,4.06l15.33,8.82.46,12.7,6.27-3.62c.05-.02.1-.05.15-.09h.02s0-.01,0-.01c.39-.29.64-.86.64-1.65v-29.31c0-1.56-.95-3.38-2.12-4.05Z"
                      />
                      <path
                        className="cls-14"
                        d="m419.5,64.59l15.33,8.82.46,12.7,6.27-3.62c.05-.02.1-.05.15-.09h.02s0-.01,0-.01c.39-.29.64-.86.64-1.65v-29.31c0-.67-.17-1.38-.46-2.03l-23.78,13.73c.37.63.85,1.16,1.37,1.47Z"
                      />
                      <path
                        className="cls-14"
                        d="m433.83,86.04l-25.76-14.84c-1.17-.68-2.12-2.49-2.12-4.06v-29.31c0-1.56.95-2.28,2.12-1.6l25.76,14.84c1.17.68,2.12,2.49,2.12,4.06v29.31c0,1.56-.95,2.28-2.12,1.6Z"
                      />
                      <path
                        className="cls-3"
                        d="m434.72,50.62l-25.76-14.84c-.71-.41-1.33-.3-1.72.19.26,0,.54.08.83.25l25.76,14.84c1.17.68,2.12,2.49,2.12,4.05v29.32c0,.62-.15,1.1-.4,1.42.76,0,1.29-.69,1.29-1.86v-29.31c0-1.56-.95-3.38-2.12-4.06Z"
                      />
                      <path
                        className="cls-6"
                        d="m432.56,83.57l-23.2-13.37c-1.06-.61-1.91-2.25-1.91-3.65v-26.41c0-1.41.86-2.05,1.91-1.45l23.2,13.37c1.06.61,1.91,2.25,1.91,3.65v26.41c0,1.41-.86,2.05-1.91,1.45Z"
                      />
                      <path
                        className="cls-1"
                        d="m428.82,65.67c0,5.02-3.52,7.05-7.87,4.54-4.34-2.51-7.87-8.61-7.87-13.63s3.52-7.05,7.87-4.54c4.34,2.51,7.87,8.61,7.87,13.62Z"
                      />
                      <path
                        className="cls-6"
                        d="m426.85,62.96c0,2.77-1.94,3.89-4.34,2.5-2.4-1.38-4.34-4.75-4.34-7.51s1.94-3.89,4.34-2.5c2.4,1.38,4.34,4.75,4.34,7.51Z"
                      />
                      <path
                        className="cls-7 camera-lens"
                        d="m424.46,61.58c0,1.24-.87,1.75-1.95,1.12-1.08-.62-1.95-2.13-1.95-3.37s.87-1.75,1.95-1.12c1.08.62,1.95,2.13,1.95,3.37Z"
                      />
                    </g>
                    <polygon
                      className="cls-6"
                      points="466.52 59.64 449.37 69.54 449.32 70.16 466.52 60.22 466.52 59.64"
                    />
                    <polygon
                      className="cls-6"
                      points="466.52 44.65 449.37 54.55 449.32 55.17 466.52 45.23 466.52 44.65"
                    />
                    <polygon
                      className="cls-6"
                      points="414.19 4.57 397.24 14.36 397.4 14.85 414.7 4.86 414.19 4.57"
                    />
                    <path
                      className="cls-2"
                      d="m461.31,90.83v-6.43l2.68-1.55v6.43l-2.68,1.55Zm.31-6.25v5.71l2.05-1.19v-5.71l-2.05,1.19Z"
                    />
                    <path
                      className="cls-2"
                      d="m452.4,95.5v-6.43l.08-.04,6.78-3.85v6.43l-.08.05-6.78,3.85Zm.31-6.25v5.71l6.23-3.54v-5.71l-6.23,3.54Z"
                    />
                  </g>
                  <path
                    className="cls-3"
                    d="m411.53,92.28c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0s1.38,2.09,0,2.88Z"
                  />
                  <path
                    className="cls-3"
                    d="m534.69,46.75c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                  />
                  <path
                    className="cls-3"
                    d="m146.15,363.64c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                  />
                  <polygon
                    className="cls-3"
                    points="517.07 335.86 407.24 272.35 385.89 284.73 354 266.36 354.53 265.44 385.89 283.5 407.24 271.12 407.5 271.28 517.6 334.94 517.07 335.86"
                  />
                  <path
                    className="cls-3"
                    d="m356.76,267.34c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                  />
                  <polygon
                    className="cls-3"
                    points="485.41 371.78 401.22 323.58 376.22 338.09 375.61 337.03 401.22 322.16 401.53 322.34 485.4 370.36 503.05 360.18 503.67 361.24 485.41 371.78"
                  />
                  <polygon
                    className="cls-3"
                    points="514.44 149.75 513.91 148.83 577.24 112.23 525.76 82.46 560.65 62.37 531.93 45.76 532.46 44.85 562.77 62.38 527.89 82.46 579.36 112.23 514.44 149.75"
                  />
                  <polygon
                    className="cls-3"
                    points="212.42 376.39 189.66 362.92 166.86 376.1 166.59 375.94 143.13 362.43 143.66 361.51 166.86 374.87 189.66 361.69 212.43 375.17 235.97 361.65 236.49 362.57 212.42 376.39"
                  />
                  <path
                    className="cls-3"
                    d="m209.86,273.42c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0s1.38,2.09,0,2.88Z"
                  />
                  <path
                    className={`cls-3 floor-light-bottom-left ${
                      light && "floor-light-movement-bottom-left"
                    }`}
                    d="m209.86,273.42c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0s1.38,2.09,0,2.88Z"
                  />
                  <g>
                    <g>
                      <path
                        className="cls-3"
                        d="m457.77,265.59l-24.41-14.1,24.41-14.1,24.41,14.1-24.41,14.1Zm-22.29-14.1l22.29,12.87,22.29-12.87-22.29-12.87-22.29,12.87Z"
                      />
                      <polygon
                        className="cls-6"
                        points="473.83 246.86 457.77 256.13 457.77 237.59 473.83 228.32 473.83 246.86"
                      />
                      <polygon
                        className="cls-13"
                        points="457.77 237.59 441.71 228.32 457.77 219.04 473.83 228.32 457.77 237.59"
                      />
                      <polygon
                        className="cls-18"
                        points="457.77 256.13 441.71 246.86 441.71 228.32 457.77 237.59 457.77 256.13"
                      />
                    </g>
                    <polygon
                      className="cls-3"
                      points="451.98 246.12 447.49 243.52 447.49 238.33 451.98 240.93 451.98 246.12"
                    />
                    <polygon
                      className="cls-18"
                      points="457.77 231.32 452.57 228.32 457.77 225.32 462.97 228.32 457.77 231.32"
                    />
                  </g>
                  <g className="cls-12">
                    <path
                      className="cls-3"
                      d="m16.49,378.47l-16.49-9.52,16.49-9.52,16.48,9.52-16.48,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m16.49,308.12l-16.49-9.52,16.49-9.52,16.48,9.52-16.48,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m350.69,97.13l-16.49-9.52,16.48-9.52,16.48,9.52-16.48,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m409.03,310.17l-16.48-9.52,16.48-9.52,16.49,9.52-16.49,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m447.49,332.88l-16.49-9.52,16.49-9.52,16.48,9.52-16.48,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m413.09,378.47l-16.48-9.52,16.48-9.52,16.49,9.52-16.49,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m292.31,378.47l-16.48-9.52,16.48-9.52,16.49,9.52-16.49,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m249.67,24.37l-16.48-9.52,16.48-9.52,16.48,9.52-16.48,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m473.64,24.37l-16.48-9.52,16.48-9.52,16.49,9.52-16.48,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m560.09,159.03l-16.48-9.52,16.48-9.52,16.49,9.52-16.48,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m560.09,245.45l-16.48-9.52,16.48-9.52,16.49,9.52-16.48,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                    <path
                      className="cls-3"
                      d="m259.38,89.76l-16.48-9.52,16.48-9.52,16.48,9.52-16.48,9.52Zm-14.36-9.52l14.36,8.29,14.36-8.29-14.36-8.29-14.36,8.29Z"
                    />
                  </g>
                  <polygon
                    className="cls-3"
                    points="439.14 205.52 413.25 190.84 394.75 201.46 394.22 200.54 413.25 189.62 439.14 204.29 456.5 194.29 457.03 195.21 439.14 205.52"
                  />
                  <path
                    className="cls-3"
                    d="m396.55,202.21c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                  />
                  <path
                    className="cls-3 floor-light-top-right"
                    d="m396.55,202.21c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                  />
                  <g>
                    <g>
                      <path
                        className="cls-3"
                        d="m207.43,331.11l-24.41-14.1,24.41-14.09,24.41,14.1-24.41,14.09Zm-22.29-14.1l22.29,12.87,22.29-12.87-22.29-12.87-22.29,12.87Z"
                      />
                      <polygon
                        className="cls-6"
                        points="223.5 312.38 207.43 321.65 207.43 303.1 223.5 293.83 223.5 312.38"
                      />
                      <polygon
                        className="cls-13"
                        points="207.43 303.1 191.37 293.83 207.43 284.56 223.49 293.83 207.43 303.1"
                      />
                      <polygon
                        className="cls-18"
                        points="207.43 321.65 191.37 312.38 191.37 293.83 207.43 303.1 207.43 321.65"
                      />
                    </g>
                    <polygon
                      className="cls-3"
                      points="201.65 311.63 197.16 309.04 197.16 303.85 201.65 306.44 201.65 311.63"
                    />
                  </g>
                  <g>
                    <g id="watch">
                      <path
                        className="cls-3"
                        d="m518.01,370.25l-31.16-17.99,47.89-27.65,31.16,17.99-47.89,27.65Zm-28.71-17.99l28.71,16.57,45.43-26.23-28.71-16.57-45.43,26.23Z"
                      />
                      <path
                        className="cls-3"
                        d="m519.83,336.6c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                      />
                      <path
                        className="cls-3"
                        d="m505.85,362.15c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                      />
                      <g>
                        <g>
                          <path
                            className="cls-6"
                            d="m561.31,289.02c-5.69-3.34-11.68-5.79-16.87-9.52v-.35c-.19-.05-.39-.07-.58-.08-.19-.14-.38-.28-.56-.42,0,.15,0,.29,0,.41-.48,0-.97-.03-1.45-.32v12.91c0,18.74-11.39,40.56-25.4,48.64l-3.89,2.24c-4.36,2.52-8.58,3.43-12.24,2.69v2.63c.82.14,1.67.21,2.53.21,1.06,0,2.15-.1,3.26-.31l.62,1.83s6.1,6.22,6.6,5.98c.49-.24,6.35,1.66,6.66,1.54.31-.12,6.47-.92,7.28-1.11.8-.19,5.36-2.9,5.36-2.9l6.75-4.69,6.45-4.81,7.83-11.35,6.04-15.23,1.79-8.1s-.16-17.3-.18-19.93Z"
                          />
                          <path
                            className="cls-3"
                            d="m501.01,346.02c3.65.73,7.87-.17,12.24-2.69l3.89-2.24c14-8.09,25.4-29.91,25.4-48.64v-12.91c.48.29.97.31,1.45.32,0-.13,0-.26,0-.41.19.14.38.28.56.42.17,0,.34.03.51.06-.2-.14-.41-.27-.61-.41v-.35c-.19-.05-.39-.07-.58-.08-.19-.14-.38-.28-.56-.42,0,.15,0,.29,0,.41-.48,0-.97-.03-1.45-.32v12.91c0,18.74-11.39,40.56-25.4,48.64l-3.89,2.24c-4.36,2.52-8.58,3.43-12.24,2.69v2.63c.22.04.45.06.68.09v-1.94Z"
                          />
                          <path
                            className="cls-3"
                            d="m559.05,308.65l-.18-.1c-2.28,16.95-12.58,34.74-24.92,41.86l-3.89,2.24c-5.74,3.31-11.23,3.84-15.51,1.5.16.11.33.21.5.31,4.31,2.49,9.9,2,15.75-1.37l3.89-2.24c12.34-7.12,22.65-24.91,24.92-41.86l.18.1c.42.24.97.37,1.55.41.02-.15.05-.3.07-.45-.87.09-1.74-.03-2.36-.39Z"
                          />
                          <path
                            className="cls-14"
                            d="m565.04,307.54v-18.11s-5.61-2.38-5.61-2.38l-20.51-8.68v18.04s0,0,0,0c0,.39.25.76.73,1.04l20.14,11.63c1.08.63,2.97.55,4.22-.18.68-.39,1.03-.89,1.03-1.37h0Z"
                          />
                          <polygon
                            className="cls-2"
                            points="564.67 289.06 558.69 286.69 538.55 278 564.67 289.06"
                          />
                          <path
                            className="cls-6"
                            d="m561.41,287.89v21.6c.89.04,1.86-.16,2.6-.59.68-.39,1.03-.89,1.03-1.37h0s0-18.11,0-18.11l-3.64-1.54Z"
                          />
                          <path
                            className="cls-13"
                            d="m559.79,291.05l-20.14-11.63c-1.08-.63-.95-1.72.3-2.44h0c1.25-.72,3.14-.8,4.22-.18l20.14,11.63c1.08.63.95,1.72-.3,2.44h0c-1.25.72-3.14.8-4.22.18Z"
                          />
                          <path
                            className="cls-13"
                            d="m534.87,252.5s-.05-.03-.08-.05c-.02-.01-.04-.02-.06-.03l-.17-.1h-.02c-5.11-2.82-11.52-2.3-18.1,1.5l-3.89,2.24c-14.72,8.5-26.69,31.33-26.69,50.89v17.02c0,10.56,3.52,18.64,9.65,22.19.32.19.65.35.98.51h0s16.88,9.79,16.88,9.79l-4.81-5.91-1.94-8.6-.37-9.9-.09-6.1v-13.6l1.2-6.84,1.29-5.55,2.68-7.09,2.54-5.4,2.36-3.38,3.19-5.36,2.17-2.64,3.28-2.54,2.4-2.13,6.1-4.58,5.53-2.65,4.81-1.29,4.38.12,4.47-.28-17.71-10.24Z"
                          />
                          <path
                            className="cls-6"
                            d="m561.86,288.43l-.21-.37h.06s-.55-4-.55-4c-.05-1.61-.1-3.02-.1-3.02,0,0-2.03-9.74-2.16-9.93-.12-.18-2.9-4.93-2.9-4.93l-9.13-3.7s-5.73.37-5.73.55c0,.01.01.07.03.15-.35.08-.7.16-1.05.26,1.12,3.17,1.72,6.95,1.72,11.2v3.91c-.06.26.08.52.42.72l17.89,10.37c.58.34,1.1-.07,1.69-.4.58-.34.6-.47.02-.8Z"
                          />
                          <path
                            className="cls-2"
                            d="m506.8,348.55c-.13.02-.26.04-.39.06l.33.98s.24.25.63.63l-.57-1.68Z"
                          />
                          <path
                            className="cls-3"
                            d="m542.53,279.32v-3.91c0-4.24-.6-8.03-1.72-11.2.34-.1.7-.18,1.05-.26-.02-.08-.03-.14-.03-.15,0-.19,5.73-.55,5.73-.55l8.83,3.58c-.23-.4-.39-.66-.39-.66l-9.13-3.7s-5.73.37-5.73.56c0,.01.01.07.03.15-.35.08-.7.16-1.05.26,1.12,3.17,1.72,6.95,1.72,11.2v3.91c-.06.26.08.52.42.72l.26.15s0-.06,0-.09Z"
                          />
                          <path
                            className="cls-5"
                            d="m562.68,288.98v-3.8c0-10.56-3.52-18.64-9.66-22.19-5.15-2.97-11.66-2.48-18.34,1.37l-3.89,2.24c-14.72,8.5-26.69,31.33-26.69,50.89v17.02c0,10.56,3.52,18.64,9.65,22.19,2.22,1.28,4.7,1.92,7.33,1.92,3.47,0,7.21-1.1,11-3.29l3.89-2.24c12.92-7.46,23.72-25.97,26.16-43.61-.87.09-1.74-.03-2.36-.39l-.18-.1c-2.28,16.95-12.58,34.74-24.92,41.86l-3.89,2.24c-5.85,3.37-11.44,3.86-15.75,1.37-5.31-3.07-8.36-10.33-8.36-19.94v-17.02c0-18.74,11.39-40.56,25.4-48.64l3.89-2.24c3.39-1.95,6.69-2.94,9.7-2.94,2.19,0,4.23.52,6.04,1.57,5.31,3.07,8.36,10.33,8.36,19.94v4.41l.07.04c.58.34,1.52.34,2.1,0,.31-.18.44-.42.42-.65h0Z"
                          />
                          <path
                            className="cls-14"
                            d="m562.68,288.98v-3.8c0-10.56-3.52-18.64-9.66-22.19-5.15-2.97-11.66-2.48-18.34,1.37l-3.89,2.24c-14.72,8.5-26.69,31.33-26.69,50.89v17.02c0,10.56,3.52,18.64,9.65,22.19,2.22,1.28,4.7,1.92,7.33,1.92,3.47,0,7.21-1.1,11-3.29l3.89-2.24c12.92-7.46,23.72-25.97,26.16-43.61-.87.09-1.74-.03-2.36-.39l-.18-.1c-2.28,16.95-12.58,34.74-24.92,41.86l-3.89,2.24c-5.85,3.37-11.44,3.86-15.75,1.37-5.31-3.07-8.36-10.33-8.36-19.94v-17.02c0-18.74,11.39-40.56,25.4-48.64l3.89-2.24c3.39-1.95,6.69-2.94,9.7-2.94,2.19,0,4.23.52,6.04,1.57,5.31,3.07,8.36,10.33,8.36,19.94v4.41l.07.04c.58.34,1.52.34,2.1,0,.31-.18.44-.42.42-.65h0Z"
                          />
                          <path
                            className="cls-3"
                            d="m552.29,262.56c-5.15-2.97-11.66-2.48-18.34,1.37l-3.89,2.24c-11.88,6.86-21.97,23.05-25.42,39.33.27.1.52.24.75.39,3.46-16.26,13.54-32.43,25.41-39.29l3.89-2.24c6.58-3.8,13-4.32,18.11-1.49-.17-.11-.34-.21-.51-.31Z"
                          />
                          <path
                            className="cls-10"
                            d="m506.13,346.98c-.17.08-.33.14-.5.19,1.65,4.09,4.15,7.23,7.39,9.1.08.05.17.09.25.13-3.16-1.99-5.58-5.24-7.14-9.42Z"
                          />
                          <path
                            className="cls-3"
                            d="m551.73,265.23c-.08-.05-.17-.09-.26-.14,5.01,3.22,7.87,10.34,7.87,19.65v4.41l.07.04s.01,0,.02.01l.65.38v-4.41c0-9.61-3.05-16.88-8.36-19.94Z"
                          />
                          <path
                            className={`cls-3 floor-light-bottom-right ${
                              light && "floor-light-movement-bottom-right"
                            }`}
                            d="m356.76,267.34c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0,1.38.8,1.38,2.09,0,2.88Z"
                          />
                        </g>
                        <path
                          className="cls-14"
                          d="m514.02,306.43l-32.62-18.83c-.82-.47-1.56-.51-2.14-.19h0s-4.49,2.59-4.49,2.59l3.31,1.28v38.11c0,2.44,1.49,5.28,3.32,6.34l31.19,18.01-.78,3.53,4.35-2.52h0c.72-.4,1.17-1.34,1.17-2.7v-39.29c0-2.44-1.49-5.28-3.32-6.34Z"
                        />
                        <path
                          className="cls-6"
                          d="m516.17,354.75h0c.72-.4,1.17-1.34,1.17-2.7v-39.29c0-1.07-.3-2.22-.78-3.26l-38.13,22.02c.54,1.78,1.66,3.45,2.97,4.21l31.19,18.01-.78,3.53,4.35-2.52Z"
                        />
                        <path
                          className="cls-13"
                          d="m509.57,357.14l-32.62-18.83c-1.83-1.06-3.32-3.9-3.32-6.34v-39.29c0-2.44,1.49-3.57,3.32-2.51l32.62,18.83c1.83,1.06,3.32,3.9,3.32,6.34v39.29c0,2.44-1.49,3.57-3.32,2.51Z"
                        />
                        <path
                          className="cls-3"
                          d="m510.49,308.56l-32.62-18.83c-.99-.57-1.88-.49-2.48.08.47-.07,1,.03,1.57.36l32.62,18.83c1.83,1.06,3.32,3.9,3.32,6.34v39.29c0,1.12-.32,1.94-.83,2.42,1.04-.15,1.75-1.18,1.75-2.87v-39.29c0-2.44-1.49-5.28-3.32-6.34Z"
                        />
                        <path
                          className="cls-6"
                          d="m508.71,355.36l-30.88-17.83c-1.74-1-3.14-3.69-3.14-6v-37.2c0-2.31,1.41-3.38,3.14-2.38l30.88,17.83c1.74,1,3.14,3.69,3.14,6v37.2c0,2.31-1.41,3.38-3.14,2.38Z"
                        />
                        <path
                          className="cls-7"
                          d="m516.56,332.59c0,.88-.62,1.95-1.38,2.39s-1.38.08-1.38-.8.62-1.95,1.38-2.39c.76-.44,1.38-.08,1.38.8Z"
                        />
                      </g>
                    </g>
                    <g id="watch-2">
                      <path
                        className="cls-7"
                        d="m491.1,321.52l-4.99-2.88c-.44-.26-.8-.94-.8-1.53v-5.48c0-.59.36-.86.8-.6l4.99,2.88c.44.26.8.94.8,1.53v5.48c0,.59-.36.86-.8.6Z"
                      />
                      <path
                        className="cls-17 watch-rec-1"
                        d="m499.81,326.55l-4.99-2.88c-.44-.25-.8-.94-.8-1.53v-5.48c0-.59.36-.86.8-.6l4.99,2.88c.44.26.8.94.8,1.53v5.48c0,.59-.36.86-.8.6Z"
                      />
                      <path
                        className="cls-3 watch-rec-2"
                        d="m491.1,331.25l-4.99-2.88c-.44-.26-.8-.94-.8-1.53v-5.48c0-.59.36-.86.8-.6l4.99,2.88c.44.26.8.94.8,1.53v5.48c0,.59-.36.86-.8.6Z"
                      />
                      <path
                        className="cls-14"
                        d="m499.81,336.28l-4.99-2.88c-.44-.26-.8-.94-.8-1.53v-5.48c0-.59.36-.86.8-.6l4.99,2.88c.44.26.8.94.8,1.53v5.48c0,.59-.36.86-.8.6Z"
                      />
                    </g>
                  </g>
                  <g>
                    <g id="bottom-computer">
                      <g>
                        <g>
                          <path
                            className="cls-18"
                            d="m116.96,337.13v-3.32h-.99c-.89-1.52-2.36-2.96-4.46-4.17-7.26-4.19-19.04-4.19-26.31,0-2.1,1.21-3.58,2.65-4.46,4.17h-.98v3.29h0c-.01,2.76,1.8,5.52,5.45,7.62,7.26,4.19,19.04,4.19,26.31,0,3.63-2.1,5.45-4.85,5.45-7.59Z"
                          />
                          <path
                            className="cls-6"
                            d="m111.51,329.64c-6.51-3.76-16.63-4.14-23.89-1.16v17.41c7.26,2.98,17.38,2.6,23.89-1.16,3.63-2.1,5.45-4.85,5.45-7.59v-3.32h-.99c-.89-1.52-2.36-2.96-4.46-4.17Z"
                          />
                          <ellipse
                            className="cls-13"
                            cx="98.36"
                            cy="333.81"
                            rx="18.6"
                            ry="10.74"
                          />
                          <path
                            className="cls-3"
                            d="m111.51,341.4c-7.26,4.19-19.04,4.19-26.31,0-3.48-2.01-5.28-4.62-5.42-7.25-.16,2.86,1.64,5.75,5.42,7.94,7.26,4.19,19.04,4.19,26.31,0,3.78-2.18,5.58-5.07,5.42-7.94-.14,2.63-1.94,5.24-5.42,7.25Z"
                          />
                        </g>
                        <g>
                          <path
                            className="cls-18"
                            d="m110.28,334.03c-.78.46-1.97.51-2.65.12l-11.34-6.49c-.3-.17-.46-.41-.46-.65h0s-.01-23.3-.01-23.3l15.08,6.34.02,23.07s0,.09,0,.14h0s0,0,0,0c-.03.28-.25.56-.64.79Z"
                          />
                          <polygon
                            className="cls-18"
                            points="95.82 312.21 95.83 321.27 110.91 329.98 110.9 318.47 97.95 310.99 95.82 312.21"
                          />
                          <path
                            className="cls-6"
                            d="m110.9,310.04l.02,23.07s0,.09,0,.14h0c-.03.28-.25.56-.64.79-.37.22-.84.34-1.3.37l-.06-25.2,1.98.83Z"
                          />
                          <path
                            className="cls-6"
                            d="m110.44,309.33l-11.34-6.49c-.68-.39-1.87-.34-2.65.12h0c-.78.46-.87,1.14-.18,1.53l11.34,6.49c.68.39,1.87.34,2.65-.12h0c.78-.46.87-1.14.18-1.53Z"
                          />
                          <path
                            className="cls-3"
                            d="m107.62,311.12l-11.34-6.49c-.31-.18-.46-.42-.46-.67.05.2.19.38.44.53l11.34,6.49c.68.39,1.87.34,2.65-.12h0c.42-.25.64-.56.64-.86.08.34-.13.72-.63,1.01h0c-.78.46-1.97.51-2.65.12Z"
                          />
                        </g>
                      </g>
                      <g>
                        <path
                          className="cls-14"
                          d="m162.33,263.95l-110.41-63.74c-1.02-.59-1.94-.62-2.66-.22h0s-3.45,2-3.45,2l2.1.3c-.05.31-.08.65-.08,1.01v76.23c0,3,1.83,6.49,4.08,7.8l110.24,63.64-.56,2.28,3.4-1.97h0c.87-.5,1.42-1.65,1.42-3.3v-76.23c0-3-1.83-6.49-4.08-7.8Z"
                        />
                        <path
                          className="cls-6"
                          d="m165,351.28h0c.87-.5,1.42-1.65,1.42-3.3v-76.23c0-1.36-.39-2.81-1.01-4.12l-73.8,42.61,70.56,40.74-.56,2.28,3.4-1.97Z"
                        />
                        <path
                          className="cls-13"
                          d="m158.83,353.09l-110.41-63.74c-2.25-1.3-4.08-4.79-4.08-7.8v-76.23c0-3,1.83-4.39,4.08-3.08l110.41,63.74c2.25,1.3,4.08,4.79,4.08,7.8v76.23c0,3-1.83,4.39-4.08,3.08Z"
                        />
                        <path
                          className="cls-3"
                          d="m159.38,265.8l-110.41-63.74c-.96-.55-1.84-.62-2.54-.28.59-.1,1.27.04,1.99.46l110.41,63.74c2.25,1.3,4.08,4.79,4.08,7.8v76.23c0,1.73-.6,2.91-1.54,3.37,1.25-.21,2.09-1.5,2.09-3.54v-76.23c0-3-1.83-6.49-4.08-7.8Z"
                        />
                        <path
                          className="cls-6"
                          d="m159.18,350.56l-111.1-64.14c-.8-.46-1.44-1.7-1.44-2.76v-77.81c0-1.06.65-1.55,1.44-1.09l111.1,64.14c.8.46,1.44,1.7,1.44,2.76v77.81c0,1.06-.65,1.55-1.44,1.09Z"
                        />
                      </g>
                    </g>
                    <g>
                      <path
                        className="cls-7 bottom-computer-rec-1"
                        d="m99.6,274.38l-7.23-4.17c-.64-.37-1.16-1.36-1.16-2.21v-7.93c0-.85.52-1.24,1.16-.88l7.23,4.17c.64.37,1.16,1.36,1.16,2.21v7.93c0,.85-.52,1.24-1.16.88Z"
                      />
                      <path
                        className="cls-17"
                        d="m112.2,281.66l-7.23-4.17c-.64-.37-1.16-1.36-1.16-2.21v-7.93c0-.85.52-1.24,1.16-.88l7.23,4.17c.64.37,1.16,1.36,1.16,2.21v7.93c0,.85-.52,1.24-1.16.88Z"
                      />
                      <path
                        className="cls-3"
                        d="m99.6,288.47l-7.23-4.17c-.64-.37-1.16-1.36-1.16-2.21v-7.93c0-.85.52-1.24,1.16-.88l7.23,4.17c.64.37,1.16,1.36,1.16,2.21v7.93c0,.85-.52,1.24-1.16.88Z"
                      />
                      <path
                        className="cls-14 bottom-computer-rec-2"
                        d="m112.2,295.75l-7.23-4.17c-.64-.37-1.16-1.36-1.16-2.21v-7.93c0-.85.52-1.24,1.16-.88l7.23,4.17c.64.37,1.16,1.36,1.16,2.21v7.93c0,.85-.52,1.24-1.16.88Z"
                      />
                    </g>
                  </g>
                  <path
                    className={`cls-3 floor-light-top-left ${
                      light && "floor-light-movement-top-left"
                    }`}
                    d="m220.44,200.64c-1.38.8-3.61.8-4.99,0-1.38-.8-1.38-2.09,0-2.88,1.38-.8,3.61-.8,4.99,0s1.38,2.09,0,2.88Z"
                  />
                  <g>
                    <g id="server-4">
                      <g>
                        <g>
                          <path
                            className="cls-14"
                            d="m257.79,199.99h0v-92.16l36.64-9.59,6.75-3.9c1.55-.89,4.25-.78,6.04.25l6.3,3.64h19.54s-5.79,88.96-5.79,88.96c.04.61-.29,1.19-1.04,1.62l-36.56,27.59c-1.55.89-4.25.78-6.04-.25l-24.37-14.07c-1.03-.6-1.53-1.37-1.47-2.09Z"
                          />
                          <path
                            className="cls-13"
                            d="m303.98,93.74c1.13.03,2.31.31,3.24.85l6.3,3.64h19.54s0,92.4,0,92.4c.04.61-.29,1.19-1.04,1.62l-42.35,24.15c-.74.43-1.76.62-2.8.6l-.44-92.99,17.55-30.26Z"
                          />
                          <path
                            className="cls-18"
                            d="m289.28,216.58c-1.34.57-3.27.54-4.83-.06v-93.62h4.83v93.68Z"
                          />
                          <path
                            className="cls-13"
                            d="m289.67,124.01l42.35-24.15c1.55-.89,1.35-2.46-.43-3.49l-24.37-14.07c-1.79-1.03-4.49-1.14-6.04-.25l-42.35,24.15c-1.55.89-1.35,2.46.43,3.49l24.37,14.07c1.79,1.03,4.49,1.14,6.04.25Z"
                          />
                          <path
                            className="cls-8"
                            d="m259.26,107.98l24.37,14.07c1.79,1.03,4.49,1.14,6.04.25l42.35-24.15c.35-.2.6-.43.77-.69.53.86.29,1.79-.77,2.4l-42.35,24.15c-1.55.89-4.25.78-6.04-.25l-24.37-14.07c-1.39-.8-1.81-1.92-1.21-2.8.24.39.65.77,1.21,1.09Z"
                          />
                          <g>
                            <path
                              className="cls-6"
                              d="m288.47,114.23l28.2-16.34c.72-.42.63-1.15-.2-1.63l-11.4-6.58c-.84-.48-2.1-.54-2.83-.12l-28.2,16.34c-.72.42-.63,1.15.2,1.63l11.4,6.58c.84.48,2.1.54,2.83.12Z"
                            />
                            <g id="top-server-top-light">
                              <path
                                className="cls-13"
                                d="m303.69,98.62l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                className="cls-13"
                                d="m298.23,101.75l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                className="cls-7"
                                d="m292.77,104.89l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                className="cls-13"
                                d="m287.32,108.03l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                            </g>
                            <path
                              className="cls-18"
                              d="m316.66,97.88l-.03.02c-.06-.04-.11-.08-.17-.12l-11.4-6.58c-.84-.48-2.1-.54-2.83-.12l-28.16,16.32c-.67-.48-.7-1.13-.03-1.52l28.2-16.34c.72-.42,1.99-.37,2.83.12l11.4,6.58c.84.48.93,1.21.2,1.63Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m278.87,142.27l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m262.04,122.83c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              className="cls-14"
                              d="m274.04,136.04l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              id="left-server-front-light-1"
                              className="cls-3"
                              d="m269.13,133.21l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m278.87,183.7l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m262.04,164.26c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              className="cls-14"
                              d="m274.04,177.47l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m269.13,174.63l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m278.87,204.41l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m262.04,184.97c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              className="cls-14"
                              d="m274.04,198.18l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m269.13,195.35l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m278.87,162.99l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m262.04,143.55c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              className="cls-14"
                              d="m274.04,156.76l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              id="left-server-front-light-2"
                              className="cls-3"
                              d="m269.13,153.92l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m292.75,136.4l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m293.81,133.93l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m321.41,115.32l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m316.98,116.89c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m313.97,118.63c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m310.96,120.37c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m307.95,122.1c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m295.28,130.98l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m292.75,148.84l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m293.81,146.37l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m321.41,127.75l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m316.98,129.33c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m313.97,131.07c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m310.96,132.8c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m307.95,134.54c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m295.28,143.41l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m292.75,161.28l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m293.81,158.8l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m321.41,140.19l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m316.98,141.77c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m313.97,143.5c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m310.96,145.24c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m307.95,146.98c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m295.28,155.85l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m292.75,173.71l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m293.81,171.24l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m321.41,152.63l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m316.98,154.2c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m313.97,155.94c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m310.96,157.68c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m307.95,159.41c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m295.28,168.29l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m292.75,186.15l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m293.81,183.68l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m321.41,165.06l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m316.98,166.64c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-3"
                          d="m313.97,168.38c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m310.96,170.11c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-3"
                          d="m307.95,171.85c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m295.28,180.72l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m292.75,198.59l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m293.81,196.11l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m321.41,177.5l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m316.98,179.07c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m313.97,180.81c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m310.96,182.55c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m307.95,184.29c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m295.28,193.16l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m292.75,211.02l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m293.81,208.55l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m321.41,189.94l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m316.03,192.18c0,1.03.72,1.44,1.61.93s1.61-1.76,1.61-2.79-.72-1.44-1.61-.93c-.89.51-1.61,1.76-1.61,2.79Z"
                        />
                        <path
                          className="cls-6"
                          d="m309.79,195.83c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m306.79,197.57c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m303.78,199.3c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m295.28,205.6l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                    </g>
                    <g id="server-3">
                      <g>
                        <g>
                          <path
                            className="cls-14"
                            d="m189.82,239.11h0v-92.16l36.64-9.59,6.75-3.9c1.55-.89,4.25-.78,6.04.25l6.3,3.64h19.54s-5.79,88.96-5.79,88.96c.04.61-.29,1.19-1.04,1.62l-36.56,27.59c-1.55.89-4.25.78-6.04-.25l-24.37-14.07c-1.03-.6-1.53-1.37-1.47-2.09Z"
                          />
                          <path
                            className="cls-13"
                            d="m236.01,132.87c1.13.03,2.31.31,3.24.85l6.3,3.64h19.54s0,92.4,0,92.4c.04.61-.29,1.19-1.04,1.62l-42.35,24.15c-.74.43-1.76.62-2.8.6l-.44-92.99,17.55-30.26Z"
                          />
                          <path
                            className="cls-18"
                            d="m221.31,255.71c-1.34.57-3.27.54-4.83-.06v-93.62h4.83v93.68Z"
                          />
                          <path
                            className="cls-13"
                            d="m221.7,163.14l42.35-24.15c1.55-.89,1.35-2.46-.43-3.49l-24.37-14.07c-1.79-1.03-4.49-1.14-6.04-.25l-42.35,24.15c-1.55.89-1.35,2.46.43,3.49l24.37,14.07c1.79,1.03,4.49,1.14,6.04.25Z"
                          />
                          <path
                            className="cls-8"
                            d="m191.29,147.11l24.37,14.07c1.79,1.03,4.49,1.14,6.04.25l42.35-24.15c.35-.2.6-.43.77-.69.53.86.29,1.79-.77,2.4l-42.35,24.15c-1.55.89-4.25.78-6.04-.25l-24.37-14.07c-1.39-.8-1.81-1.92-1.21-2.8.24.39.65.77,1.21,1.09Z"
                          />
                          <g>
                            <path
                              className="cls-6"
                              d="m220.5,153.35l28.2-16.34c.72-.42.63-1.15-.2-1.63l-11.4-6.58c-.84-.48-2.1-.54-2.83-.12l-28.2,16.34c-.72.42-.63,1.15.2,1.63l11.4,6.58c.84.48,2.1.54,2.83.12Z"
                            />
                            <g>
                              <path
                                className="cls-13"
                                d="m235.72,137.74l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                id="left-server-top-light"
                                className="cls-7"
                                d="m230.26,140.88l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                className="cls-7"
                                d="m224.81,144.02l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                className="cls-13"
                                d="m219.35,147.16l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                            </g>
                            <path
                              className="cls-18"
                              d="m248.7,137.01l-.03.02c-.05-.04-.11-.08-.17-.12l-11.4-6.58c-.84-.48-2.1-.54-2.83-.12l-28.16,16.32c-.67-.48-.7-1.13-.03-1.52l28.2-16.34c.72-.42,1.99-.37,2.83.12l11.4,6.58c.84.48.93,1.21.2,1.63Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m210.9,181.4l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m194.07,161.96c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              className="cls-14"
                              d="m206.08,175.17l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m201.16,172.33l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m210.9,222.83l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m194.07,203.39c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              className="cls-7"
                              d="m206.08,216.6l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m201.16,213.76l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m210.9,243.54l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m194.07,224.1c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              className="cls-14"
                              d="m206.08,237.31l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              id="left-server-front-light-4"
                              className="cls-3"
                              d="m201.16,234.47l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m210.9,202.11l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m194.07,182.67c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              id="left-server-front-light-2-2"
                              className="cls-7"
                              d="m206.08,195.89l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m201.16,193.05l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m224.78,175.53l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m225.85,173.06l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m253.44,154.45l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m249.01,156.02c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m246,157.76c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m242.99,159.49c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m239.98,161.23c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m227.31,170.11l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m224.78,187.97l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m225.85,185.49l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m253.44,166.88l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m249.01,168.46c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m246,170.19c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m242.99,171.93c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m239.98,173.67c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m227.31,182.54l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m224.78,200.4l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m225.85,197.93l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m253.44,179.32l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m249.01,180.89c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m246,182.63c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m242.99,184.37c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m239.98,186.1c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m227.31,194.98l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m224.78,212.84l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m225.85,210.37l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m253.44,191.75l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m249.01,193.33c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m246,195.07c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m242.99,196.8c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m239.98,198.54c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m227.31,207.41l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m224.78,225.28l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m225.85,222.8l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m253.44,204.19l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m249.01,205.77c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-3"
                          d="m246,207.5c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m242.99,209.24c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-3"
                          d="m239.98,210.98c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m227.31,219.85l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m224.78,237.71l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m225.85,235.24l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m253.44,216.63l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m249.01,218.2c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m246,219.94c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m242.99,221.68c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m239.98,223.41c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m227.31,232.29l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m224.78,250.15l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m225.85,247.68l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m253.44,229.06l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m248.06,231.31c0,1.03.72,1.44,1.61.93.89-.51,1.61-1.76,1.61-2.79s-.72-1.44-1.61-.93c-.89.51-1.61,1.76-1.61,2.79Z"
                        />
                        <path
                          className="cls-6"
                          d="m241.83,234.96c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m238.82,236.69c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m235.81,238.43c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m227.31,244.72l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                    </g>
                    <g id="server-2">
                      <g>
                        <g>
                          <path
                            className="cls-14"
                            d="m310.42,230.26h0v-92.16l36.64-9.59,6.75-3.9c1.55-.89,4.25-.78,6.04.25l6.3,3.64h19.54s-5.79,88.96-5.79,88.96c.04.61-.29,1.19-1.04,1.62l-36.56,27.59c-1.55.89-4.25.78-6.04-.25l-24.37-14.07c-1.03-.6-1.53-1.37-1.47-2.09Z"
                          />
                          <path
                            className="cls-13"
                            d="m356.61,124.02c1.13.03,2.31.31,3.24.85l6.3,3.64h19.54s0,92.4,0,92.4c.04.61-.29,1.19-1.04,1.62l-42.35,24.15c-.74.43-1.76.62-2.8.6l-.44-92.99,17.55-30.26Z"
                          />
                          <path
                            className="cls-18"
                            d="m341.91,246.86c-1.34.57-3.27.54-4.83-.06v-93.62h4.83v93.68Z"
                          />
                          <path
                            className="cls-13"
                            d="m342.3,154.29l42.35-24.15c1.55-.89,1.35-2.46-.43-3.49l-24.37-14.07c-1.79-1.03-4.49-1.14-6.04-.25l-42.35,24.15c-1.55.89-1.35,2.46.43,3.49l24.37,14.07c1.79,1.03,4.49,1.14,6.04.25Z"
                          />
                          <path
                            className="cls-8"
                            d="m311.89,138.26l24.37,14.07c1.79,1.03,4.49,1.14,6.04.25l42.35-24.15c.35-.2.6-.43.77-.69.53.86.29,1.79-.77,2.4l-42.35,24.15c-1.55.89-4.25.78-6.04-.25l-24.37-14.07c-1.39-.8-1.81-1.92-1.21-2.8.24.39.65.77,1.21,1.09Z"
                          />
                          <g>
                            <path
                              className="cls-6"
                              d="m341.11,144.5l28.2-16.34c.72-.42.63-1.15-.2-1.63l-11.4-6.58c-.84-.48-2.1-.54-2.83-.12l-28.2,16.34c-.72.42-.63,1.15.2,1.63l11.4,6.58c.84.48,2.1.54,2.83.12Z"
                            />
                            <g>
                              <path
                                className="cls-7"
                                d="m356.33,128.89l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                id="right-server-top-front-light"
                                className="cls-13"
                                d="m350.87,132.03l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                className="cls-13"
                                d="m345.41,135.17l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                className="cls-7"
                                d="m339.95,138.31l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                            </g>
                            <path
                              className="cls-18"
                              d="m369.3,128.16l-.03.02c-.06-.04-.11-.08-.17-.12l-11.4-6.58c-.84-.48-2.1-.54-2.83-.12l-28.16,16.32c-.67-.48-.7-1.13-.03-1.52l28.2-16.34c.72-.42,1.99-.37,2.83.12l11.4,6.58c.84.48.93,1.21.2,1.63Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m331.5,172.55l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m314.68,153.11c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g id="right-server-front-light-1">
                            <path
                              className="cls-14"
                              d="m326.68,166.32l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m321.76,163.48l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m331.5,213.98l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m314.68,194.54c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              className="cls-14"
                              d="m326.68,207.75l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              id="right-server-front-light-3"
                              className="cls-3"
                              d="m321.76,204.91l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m331.5,234.69l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m314.68,215.25c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g id="server-top-right-light-rec1">
                            <path
                              className="cls-14"
                              d="m326.68,228.46l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m321.76,225.62l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m331.5,193.26l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m314.68,173.82c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              className="cls-14"
                              d="m326.68,187.04l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m321.76,184.2l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m345.39,166.68l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m346.45,164.21l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m374.05,145.6l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m369.61,147.17c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m366.6,148.91c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m363.6,150.64c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m360.59,152.38c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m347.92,161.26l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m345.39,179.12l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m346.45,176.65l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m374.05,158.03l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m369.61,159.61c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m366.6,161.34c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m363.6,163.08c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m360.59,164.82c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m347.92,173.69l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m345.39,191.55l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m346.45,189.08l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m374.05,170.47l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m369.61,172.04c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m366.6,173.78c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m363.6,175.52c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m360.59,177.25c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m347.92,186.13l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m345.39,203.99l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m346.45,201.52l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m374.05,182.9l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m369.61,184.48c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m366.6,186.22c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m363.6,187.95c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m360.59,189.69c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m347.92,198.57l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m345.39,216.43l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m346.45,213.95l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m374.05,195.34l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m369.61,196.92c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-3"
                          d="m366.6,198.65c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m363.6,200.39c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-3"
                          d="m360.59,202.13c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m347.92,211l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m345.39,228.86l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m346.45,226.39l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m374.05,207.78l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m369.61,209.35c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m366.6,211.09c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m363.6,212.83c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m360.59,214.56c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m347.92,223.44l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m345.39,241.3l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m346.45,238.83l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m374.05,220.21l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m368.66,222.46c0,1.03.72,1.44,1.61.93.89-.51,1.61-1.76,1.61-2.79s-.72-1.44-1.61-.93-1.61,1.76-1.61,2.79Z"
                        />
                        <path
                          className="cls-6"
                          d="m362.43,226.11c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m359.42,227.84c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m356.41,229.58c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m347.92,235.87l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                    </g>
                    <g id="server-1">
                      <g>
                        <g>
                          <path
                            className="cls-14"
                            d="m242.45,269.39h0v-92.16l36.64-9.59,6.75-3.9c1.55-.89,4.25-.78,6.04.25l6.3,3.64h19.54s-5.79,88.96-5.79,88.96c.04.61-.29,1.19-1.04,1.62l-36.56,27.59c-1.55.89-4.25.78-6.04-.25l-24.37-14.07c-1.03-.6-1.53-1.37-1.47-2.09Z"
                          />
                          <path
                            className="cls-13"
                            d="m288.65,163.14c1.13.03,2.31.31,3.24.85l6.3,3.64h19.54s0,92.4,0,92.4c.04.61-.29,1.19-1.04,1.62l-42.35,24.15c-.74.43-1.76.62-2.8.6l-.44-92.99,17.55-30.26Z"
                          />
                          <path
                            className="cls-18"
                            d="m273.95,285.99c-1.34.57-3.27.54-4.83-.06v-93.62h4.83v93.68Z"
                          />
                          <path
                            className="cls-13"
                            d="m274.34,193.42l42.35-24.15c1.55-.89,1.35-2.46-.43-3.49l-24.37-14.07c-1.79-1.03-4.49-1.14-6.04-.25l-42.35,24.15c-1.55.89-1.35,2.46.43,3.49l24.37,14.07c1.79,1.03,4.49,1.14,6.04.25Z"
                          />
                          <path
                            className="cls-8"
                            d="m243.93,177.39l24.37,14.07c1.79,1.03,4.49,1.14,6.04.25l42.35-24.15c.35-.2.6-.43.77-.69.53.86.29,1.79-.77,2.4l-42.35,24.15c-1.55.89-4.25.78-6.04-.25l-24.37-14.07c-1.39-.8-1.81-1.92-1.21-2.8.24.39.65.77,1.21,1.09Z"
                          />
                          <g>
                            <path
                              className="cls-6"
                              d="m273.14,183.63l28.2-16.34c.72-.42.63-1.15-.2-1.63l-11.4-6.58c-.84-.48-2.1-.54-2.83-.12l-28.2,16.34c-.72.42-.63,1.15.2,1.63l11.4,6.58c.84.48,2.1.54,2.83.12Z"
                            />
                            <g>
                              <path
                                className="cls-7"
                                d="m288.36,168.02l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                id="bottom-server-top-light"
                                className="cls-13"
                                d="m282.9,171.16l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                className="cls-13"
                                d="m277.44,174.3l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                              <path
                                className="cls-13"
                                d="m271.98,177.44l1.63-.94c.1-.06.09-.16-.03-.23l-1.58-.91c-.12-.07-.29-.07-.39-.02l-1.63.94c-.1.06-.09.16.03.23l1.58.91c.12.07.29.07.39.02Z"
                              />
                            </g>
                            <path
                              className="cls-18"
                              d="m301.33,167.29l-.03.02c-.06-.04-.11-.08-.17-.12l-11.4-6.58c-.84-.48-2.1-.54-2.83-.12l-28.16,16.32c-.67-.48-.7-1.13-.03-1.52l28.2-16.34c.72-.42,1.99-.37,2.83.12l11.4,6.58c.84.48.93,1.21.2,1.63Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m263.54,211.68l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m246.71,192.24c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g id="server-bottom-right-light-rec2">
                            <path
                              className="cls-7"
                              d="m258.71,205.45l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m253.8,202.61l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m263.54,253.1l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m246.71,233.66c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g id="server-bottom-right-light-rec1">
                            <path
                              className="cls-14"
                              d="m258.71,246.88l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m253.8,244.04l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m263.54,273.82l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m246.71,254.38c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              id="right-server-front-light-4"
                              className="cls-14"
                              d="m258.71,267.59l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              className="cls-3"
                              d="m253.8,264.75l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                        <g>
                          <path
                            className="cls-6"
                            d="m263.54,232.39l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-1.2.73-1.76,1.63-1.23l16.03,9.18c.9.52,1.63,1.92,1.63,3.12v5.73c0,1.2-.73,1.76-1.63,1.23Z"
                          />
                          <path
                            className="cls-3"
                            d="m246.71,212.95c-.25.24-.41.64-.41,1.19v5.73c0,1.2.73,2.6,1.63,3.12l16.03,9.18c.29.17.56.21.79.17-.3.28-.73.32-1.22.04l-16.03-9.18c-.9-.52-1.63-1.92-1.63-3.12v-5.73c0-.82.34-1.32.84-1.41Z"
                          />
                          <g>
                            <path
                              className="cls-14"
                              d="m258.71,226.16l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                            <path
                              id="right-server-front-light-2"
                              className="cls-3"
                              d="m253.8,223.32l-1.47-.85c-.2-.11-.36-.42-.36-.68v-1.57c0-.26.16-.38.36-.27l1.47.85c.2.11.36.42.36.68v1.57c0,.26-.16.38-.36.27Z"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m277.42,205.81l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m278.48,203.34l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m306.08,184.72l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m301.65,186.3c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m298.64,188.03c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m295.63,189.77c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m292.62,191.51c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m279.95,200.38l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m277.42,218.25l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m278.48,215.77l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m306.08,197.16l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m301.65,198.73c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m298.64,200.47c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m295.63,202.21c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m292.62,203.94c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m279.95,212.82l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m277.42,230.68l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m278.48,228.21l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m306.08,209.6l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m301.65,211.17c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m298.64,212.91c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m295.63,214.64c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m292.62,216.38c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m279.95,225.26l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m277.42,243.12l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m278.48,240.65l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m306.08,222.03l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m301.65,223.61c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m298.64,225.34c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m295.63,227.08c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m292.62,228.82c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m279.95,237.69l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m277.42,255.55l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m278.48,253.08l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m306.08,234.47l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m301.65,236.04c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-3"
                          d="m298.64,237.78c0,.54.38.76.85.49s.85-.93.85-1.48-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m295.63,239.52c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-3"
                          d="m292.62,241.25c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m279.95,250.13l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m277.42,267.99l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m278.48,265.52l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m306.08,246.9l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-6"
                          d="m301.65,248.48c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m298.64,250.22c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m295.63,251.95c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m292.62,253.69c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m279.95,262.57l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.47.36Z"
                        />
                      </g>
                      <g>
                        <path
                          className="cls-18"
                          d="m277.42,280.43l36.99-21.35c.83-.48,1.5-1.76,1.5-2.86v-7.05c0-1.1-.67-1.61-1.5-1.13l-36.99,21.35c-.83.48-1.5,1.76-1.5,2.86v7.05c0,1.1.67,1.61,1.5,1.13Z"
                        />
                        <path
                          className="cls-11"
                          d="m278.48,277.95l34.86-20.13c.42-.24.76-.89.76-1.45v-5.3c0-.56-.34-.82-.76-.57l-34.86,20.13c-.42.24-.76.89-.76,1.45v5.3c0,.56.34.82.76.57Z"
                        />
                        <path
                          className="cls-13"
                          d="m306.08,259.34l5.2-3c.41-.24.74-.87.74-1.41h0c0-.54-.33-.79-.74-.56l-5.2,3c-.41.24-.74.87-.74,1.41h0c0,.54.33.79.74.56Z"
                        />
                        <path
                          className="cls-3"
                          d="m300.69,261.59c0,1.03.72,1.44,1.61.93s1.61-1.76,1.61-2.79-.72-1.44-1.61-.93c-.89.51-1.61,1.76-1.61,2.79Z"
                        />
                        <path
                          className="cls-6"
                          d="m294.46,265.24c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m291.46,266.97c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49c-.47.27-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-6"
                          d="m288.45,268.71c0,.54.38.76.85.49.47-.27.85-.93.85-1.48s-.38-.76-.85-.49-.85.93-.85,1.48Z"
                        />
                        <path
                          className="cls-13"
                          d="m279.95,275l1.75-1.01c.26-.15.47-.56.47-.91v-1.85c0-.35-.21-.51-.47-.36l-1.75,1.01c-.26.15-.47.56-.47.91v1.85c0,.35.21.51.0000000000047.36Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Hero;
